import { FC, useEffect, useRef, useState } from 'react';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

const Tooltip: FC<MuiTooltipProps> = (props) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isTextTruncated, setIsTextTruncated] = useState(false);

  useEffect(() => {
    const compareSize = () => {
      if (ref.current) {
        setIsTextTruncated(ref.current.scrollWidth > ref.current.clientWidth);
      }
    };
    compareSize();
    window.addEventListener('resize', compareSize);

    return () => window.removeEventListener('resize', compareSize);
  }, []);

  return (
    <MuiTooltip {...props} variant={isTextTruncated ? 'dark' : 'light'}>
      <span
        ref={ref}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          display: 'flex',
        }}
      >
        {props.children}
      </span>
    </MuiTooltip>
  );
};

export default Tooltip;
